import { find } from 'lodash'

export default {
  computed: {
    programIsPublished () {
      return this.program.status === 'published'
    },

    programIsDraft () {
      return this.program.status === 'draft'
    },

    programIsScheduled () {
      return this.programIsPublished &&
        this.program.contextual_status === 'scheduled'
    },

    programIsActive () {
      return this.programIsPublished &&
        this.program.contextual_status === 'active'
    },

    programIsComplete () {
      return this.programIsPublished &&
        this.program.contextual_status === 'complete'
    },

    programIsArchived () {
      return this.program.archived
    }
  },

  methods: {
    programFindPlacement (number) {
      let placement = find(this.program.placements, { number })

      if (placement) {
        return placement
      }

      throw new Error(`Unable to find placement ${number} on program.`)
    }
  }
}
